import React from "react";
import classnames from "classnames";

import "./IconCircle.scss";

interface IconCircleProps {
  icon?: React.ReactNode;
  type?: string;
}

const IconCircle = ({ icon, type }: IconCircleProps) => {
  return <div className={classnames(`icon-circle ${type}-circle`)}>{icon}</div>;
};

export default IconCircle;
